module.exports = __webpack_public_path__ + "static/media/599.7554(26).252d9a7e.pdf";